import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { BiCartAdd, BiCartDownload } from "react-icons/bi";
import { ProductContext } from "../../Contexts/ProductContext";
import { AuthContext } from "../../Contexts/AuthContext";
import { addRemoveProductToCart, isProductInCart } from "../../Utils/cartUtils.jsx";
import {
  addRemoveProductToWishlist,
  isProductInWishlist,
} from "../../Utils/wishlistUtils";
import "./ProductCardStyle.css";
import "./Ecart.css";
import Carousel from "./Carousel.jsx";
import PriceTag from "../global/PriceTag.jsx";
import { CartOperation } from "../../Utils/constant.js";
import { motion } from "framer-motion";

const ProductCard = ({ product }) => {
  const { productState, productDispatch, orderState, orderDispatch } = useContext(ProductContext);
  const { authState } = useContext(AuthContext);
  const [cartBtnDisabled, setCartBtnDisabled] = useState(false);
  const [wishlistBtnDisabled, setWishlistBtnDisabled] = useState(false);

  const navigate = useNavigate();
  const isLogged = authState?.mobile?.length > 0;


  const addToCartHandler = (product) => {
    if (isLogged) {
      if (isProductInCart(productState?.cartIds, product?.prdId)) {
        navigate("/cart");
      } else {
        addRemoveProductToCart(
          product,
          productDispatch,
          authState?.mobile,
          CartOperation.add,
          setCartBtnDisabled,
          productState?.cart
          , orderState, orderDispatch
        );
      }
    } else {
      navigate("/login");
    }
  };

  const addToWishlistHandler = (product) => {
    if (isLogged) {
      if (isProductInWishlist(productState?.wishlistIds, product?.prdId)) {
        addRemoveProductToWishlist(
          product,
          productDispatch,
          authState?.mobile,
          false,
          setWishlistBtnDisabled
        );
      } else {
        addRemoveProductToWishlist(
          product,
          productDispatch,
          authState?.mobile,
          true,
          setWishlistBtnDisabled
        );
      }
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <motion.div animate={{ y: [0, -8, 0] }}
        whileHover={{ rotate: -2, scale: 1.02 }}
        transition={{
          y: { duration: 1.8, repeat: Infinity, ease: "easeInOut" },
          rotate: { type: "spring", stiffness: 300, damping: 20 },
          scale: { type: "spring", stiffness: 300, damping: 20 }
        }} className="product-card">
        <p className="product-brand">{product.catgName}</p>
        <div className="product-card-top">
          <button
            onClick={() => addToWishlistHandler(product)}
            className={`pc-center ${isProductInWishlist(productState?.wishlistIds, product?.prdId)
              ? "wishlist"
              : ""
              } ${wishlistBtnDisabled && "wishlist-disabled"}`}
            disabled={wishlistBtnDisabled}
          >
            {isProductInWishlist(productState?.wishlistIds, product?.prdId) ? (
              <AiFillHeart />
            ) : (
              <AiOutlineHeart />
            )}
          </button>
          <p>{product.wishlistCount > 0 && `${product.wishlistCount}+`}</p>
        </div>
        <div className="div-img-container" style={{ background: "rgba(0, 0, 0, 0)" }} >
          <Carousel images={product.images} alt={product.name} />
        </div>
        <div className="product-body">
          <div className="product-brand-review">
            <p className="product-brand">{product.brand}</p>
          </div>
          <h3 className="product-item-name"
            onPointerDown={() => navigate("/view/products", { state: { inventory: product } })}
          >{product.name}</h3>
          {/* <p>{product._id}</p> */}
          <div className="product-price">
            <PriceTag product={product} />
            <span style={{ color: "var(--dark-background-color)", fontWeight: 300, fontSize: "0.7rem" }}>
              {` (${product.quantityShow})`}
            </span>
          </div>
          <p className="product-type">{product.movementType}</p>
          <button
            className={`product-cart-btn pc-center ${cartBtnDisabled && "cart-disabled"
              }`}
            onClick={() => addToCartHandler(product)}
            disabled={cartBtnDisabled}
          >
            {isProductInCart(productState?.cartIds, product?.prdId) ? (
              <p className="pc-center">
                <BiCartDownload className="cartIcon" /> Go To Cart
              </p>
            ) : (
              <p className="pc-center">
                <BiCartAdd className="cartIcon" />
                Add To Cart
              </p>
            )}
          </button>
          <p className="product-cart-added">{product.cartCount > 0 && `${product.cartCount} added to cart`}</p>
        </div>
      </motion.div >
    </>
  );
};
export { ProductCard };
